export default __webpack_public_path__ + "static/media/community.a8c53933.svg";